var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showPop,
          expression: "showPop"
        }
      ],
      attrs: { value: _vm.value }
    },
    [
      _c(
        "van-dialog",
        {
          attrs: { "show-cancel-button": "", confirmButtonText: "保存" },
          on: { confirm: _vm.add },
          model: {
            value: _vm.showPop,
            callback: function($$v) {
              _vm.showPop = $$v
            },
            expression: "showPop"
          }
        },
        [
          _c(
            "van-cell-group",
            [
              _c(
                "van-cell",
                { attrs: { title: "名称" } },
                [
                  _c("van-field", {
                    staticClass: "item2",
                    attrs: { placeholder: "请输入名称" },
                    on: {
                      input: function($event) {
                        return _vm.limitLength(64, "obj", "Name")
                      }
                    },
                    model: {
                      value: _vm.obj.Name,
                      callback: function($$v) {
                        _vm.$set(_vm.obj, "Name", $$v)
                      },
                      expression: "obj.Name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-cell",
                { attrs: { title: "数量" } },
                [
                  _c("van-field", {
                    staticClass: "item2",
                    attrs: { type: "number", placeholder: "请输入数量" },
                    on: {
                      input: function($event) {
                        return _vm.limitLength(15, "obj", "U_Qty")
                      }
                    },
                    model: {
                      value: _vm.obj.U_Qty,
                      callback: function($$v) {
                        _vm.$set(_vm.obj, "U_Qty", $$v)
                      },
                      expression: "obj.U_Qty"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-cell",
                { attrs: { title: "含税金额" } },
                [
                  _c("van-field", {
                    staticClass: "item2",
                    attrs: {
                      type: "number",
                      maxlength: "15",
                      placeholder: "请输入含税金额"
                    },
                    on: { input: _vm.weiShui },
                    model: {
                      value: _vm.obj.U_AmountAftTax,
                      callback: function($$v) {
                        _vm.$set(_vm.obj, "U_AmountAftTax", $$v)
                      },
                      expression: "obj.U_AmountAftTax"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-cell",
                { attrs: { title: "未税金额" } },
                [
                  _c("van-field", {
                    staticClass: "item2",
                    attrs: {
                      type: "number",
                      maxlength: "15",
                      placeholder: "请输入未税金额"
                    },
                    on: { input: _vm.hanShui },
                    model: {
                      value: _vm.obj.U_Amount,
                      callback: function($$v) {
                        _vm.$set(_vm.obj, "U_Amount", $$v)
                      },
                      expression: "obj.U_Amount"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6203c09b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6203c09b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/component/yusuanPop.vue
// module id = null
// module chunks = 